module.exports = __webpack_public_path__ + "static/media/loder1.2c3c3de6.gif";